module.exports = __webpack_public_path__ + "img/gb-wls.gb-wls910c0fb.svg";